import styled, { css } from 'styled-components';

const FirstRadioStyles = css`
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
`;

const LastRadioStyles = css`
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  margin-bottom: 0;
`;

const ActiveRadioStyles = css`
  background-color: #ebfbf5;
  border-color: ${(props) => props.theme.colors.action};
  box-shadow: inset 0 0 0 1px ${(props) => props.theme.colors.action};
  z-index: 2;
`;

const RadioHoverStyles = css`
  :hover {
    cursor: pointer;
    border: 1px solid ${(props) => props.theme.colors.action};
    z-index: 2;
  }
`;

export const RadioWrapper = styled.label<{
  first?: boolean;
  last?: boolean;
  isActive: boolean;
  disabled?: boolean;
}>`
  padding: 16px;
  display: block;
  border: 1px solid ${(props) => props.theme.colors.stroke};
  margin-bottom: -1px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  text-align: left;
  ${(props) => props.first && FirstRadioStyles}
  ${(props) => props.last && LastRadioStyles}


  ${(props) => props.theme.typography.description};
  font-weight: 400;

  ${(props) => props.isActive && ActiveRadioStyles}
  ${(props) => !props.disabled && RadioHoverStyles}
`;

export const RadioDescription = styled.p`
  margin-top: 4px;
  color: ${(props) => props.theme.colors.muted};
`;

export const FlexBlock = styled.div`
  width: 100%;
`;
